<div class="row" *ngIf="render">
  <div class="col-md-6 col-xl-4 pe-5" style="border-right: 1px solid #d7d7d7">
    <h1 class="page-title mb-4">Run Correction Payroll</h1>
    <div class="row">
      <div class="col-5">
        <label>Type of Payroll</label>
        <input
          disabled
          class="form-control"
          value="Correction"
          [ngStyle]="{ 'background-color': payroll != null ? '#e9ecef' : '#f1f2f3' }" />
      </div>
      <div class="col-7">
        <label>Source</label>
        <select
          [(ngModel)]="selSource"
          [disabled]="payroll != null"
          class="form-control"
          data-testid="selCorrectionSource"
          [ngClass]="{ 'ng-invalid ng-touched': showFormErrors && !selSource }">
          <option disabled selected [ngValue]="null">Select Source</option>
          <option>Client</option>
          <option>CP Team Member</option>
        </select>
        <div class="input-error show-untouched" *ngIf="showFormErrors && !selSource">*required</div>
      </div>
    </div>
    <div class="row">
      <div [ngClass]="payroll == null ? 'col-7' : 'col-12'">
        <label>Available Paydates</label>
        <select
          [(ngModel)]="selPayroll"
          (ngModelChange)="onPayrollChange()"
          [disabled]="payroll != null"
          class="form-control"
          data-testid="selPayrollCorrection"
          [ngClass]="{ 'ng-invalid ng-touched': showFormErrors && !selPayroll }">
          <option disabled selected [ngValue]="null">Select Paydate</option>
          <ng-container *ngFor="let p of payrollOptions">
            <option [ngValue]="p">
              Payroll # {{ p.PayrollSeq }} - Paydate {{ p.PayDate | date: 'MM/dd/yyyy' }}
            </option>
          </ng-container>
        </select>
        <div class="input-error show-untouched" *ngIf="showFormErrors && !selPayroll">
          *required
        </div>
      </div>
      <div class="col-5" *ngIf="payroll == null">
        <label>&nbsp;</label>
        <div class="d-flex w-100">
          <div
            class="text-center load-more-container"
            [ngStyle]="{ opacity: payrollOptionsHidden.length ? '1' : '0.5' }">
            <div *ngIf="payrollOptionsHidden.length && isLoading">Loading paydates...</div>
            <div *ngIf="payrollOptionsHidden.length && !isLoading">
              Showing {{ payrollOptions.length }} paydates
              <a class="d-block" (click)="loadNextPayrolls(3)">
                <strong>Click to load more</strong></a
              >
            </div>
            <div *ngIf="!payrollOptionsHidden.length">All paydates loaded</div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-relative">
      <label>Person</label>
      <select
        [(ngModel)]="selPayline"
        [ngClass]="{ 'ng-invalid ng-touched': showFormErrors && !selPayline }"
        class="form-control"
        data-testid="selPaylineCorrection">
        <option disabled selected [ngValue]="null">Select Person</option>
        <ng-container *ngFor="let p of paylines">
          <!--
          VOIDED or PENDING Paylines
          voided paylines have already been submitted and exist on the history of that submitted correction payroll
          pending paylines exist on the currently active payroll and do not yet have the VOID payline type
        -->
          <option
            style="color: #ff4300"
            *ngIf="p.Payline.IsVoided == 'Y' || p.IsPending; else eligiblePays"
            disabled
            [ngValue]="p">
            *{{ p.Payline.IsVoided == 'Y' ? 'Voided' : 'Pending' }} ({{
              payrollMgmt.getEmployeeFullName(p.EmployeePay)
            }}
            <span *ngIf="p.Payline.NetAmountPaid">
              - {{ Math.abs(p.Payline.NetAmountPaid) | currency }}</span
            ><span *ngIf="p.Payline.OverrideCheckNumber">
              -
              {{ checkNumberDisplay(p.Payline.OverrideCheckNumber) }}</span
            >)
          </option>
          <!-- eligible to be voided -->
          <ng-template #eligiblePays>
            <option [ngValue]="p">
              {{ payrollMgmt.getEmployeeFullName(p.EmployeePay) }}
              <span *ngIf="p.Payline.NetAmountPaid">
                - {{ Math.abs(p.Payline.NetAmountPaid) | currency }}</span
              ><span *ngIf="p.Payline.OverrideCheckNumber">
                - {{ checkNumberDisplay(p.Payline.OverrideCheckNumber) }}</span
              >
            </option>
          </ng-template>
        </ng-container>
      </select>
      <div class="input-error show-untouched" *ngIf="showFormErrors && !selPayline">*required</div>
    </div>
    <div class="my-4 d-flex justify-content-end">
      <button class="btn btn-secondary me-3" routerLink="/client/{{ clientCode }}/payroll-landing">
        Return to Payroll Hub
      </button>
      <div (mouseenter)="showFormErrors = true">
        <button
          class="btn btn-primary"
          (click)="startPayrollCorrection()"
          [disabled]="!selPayroll || !selPayline || !selSource">
          Correct Pay
        </button>
      </div>
    </div>
    <div>
      <small>
        *Correction payrolls allow you to fix errors that were made in previous payroll cycles. For
        most payroll mistakes, time is of the essence when it comes to fixing them. If you don’t see
        the payroll you are looking for, please get in touch with your supervisor.
      </small>
    </div>
  </div>
  <div *ngIf="payroll?.EmployeePays" class="col-md-6 col-xl-4 ps-5 mt-5 ms-5">
    <p>Pending Payroll Corrections</p>
    <div class="bg-grey">
      <ul class="no-style py-2" style="height: 245px; border-radius: 10px; overflow: auto">
        <ng-container *ngFor="let empPay of payroll?.EmployeePays">
          <ng-container *ngFor="let payline of empPay.Paylines">
            <li *ngIf="payline.OkToPay" class="py-1 px-3">
              {{ payrollMgmt.getEmployeeFullName(empPay) }}
              <span *ngIf="payline.NetAmountPaid">
                -
                {{ Math.abs(payline.NetAmountPaid) | currency }}
              </span>
              <span *ngIf="payline.OverrideCheckNumber">
                -
                {{ checkNumberDisplay(payline.OverrideCheckNumber) }}
              </span>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary me-3" (click)="cancelPayroll()">Cancel Payroll</button>
      <button class="btn btn-primary" (click)="showBillings()">Review & Submit</button>
    </div>
  </div>
</div>
